import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import PlusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";
import {
  MyDocumentsInfoCard,
  MyDocumentsUploadFiles,
  MyDocumentsUploaders,
} from "my-documents/components";
import { useMyDocumetsUploaders } from "my-documents/hooks";
import { OcCard, OcPageTransition } from "oc/components";

interface MyDocumentsDataPanelProps {
  isUploader: boolean;
  isUser?: boolean;
  contractCode: string;
}

export const MyDocumentsDataPanel: React.FC<MyDocumentsDataPanelProps> = ({
  isUploader,
  isUser,
  contractCode,
}) => {
  const { t, i18n } = useTranslation();

  const { data, loading, error } = useMyDocumetsUploaders({
    contractCode: contractCode,
    locale: i18n.language,
  });

  const [showNewCard, setShowNewCard] = useState(false);
  const [editDocument, setEditDocument] = useState(null);

  const handleButtonClick = () => {
    setShowNewCard(true);
  };

  const handleEditDocument = (document: any) => {
    setEditDocument(document);
  };

  const handleCloseEdit = () => {
    setEditDocument(null);
  };

  return (
    <OcPageTransition>
      <Box id="MyHrDocumentsDataPanel">
        {showNewCard ? (
          <Box>
            <MyDocumentsUploadFiles setShowNewCard={setShowNewCard} contractCode={contractCode} />
          </Box>
        ) : editDocument ? (
          <Box>
            <Box>
              <MyDocumentsInfoCard
                isUploader={isUploader}
                isUser={!!isUser}
                contractCode={contractCode}
                editDocument={editDocument}
                onCloseEdit={handleCloseEdit}
              />
            </Box>
          </Box>
        ) : (
          <Box>
            <OcCard label={t("MY_DOCUMENTS_DOCUMENTS")} loading={loading}>
              <Box height="16px" />
              {!isUser && isUploader && (
                <Box display="flex" justifyContent="flex-end">
                  <Box>
                    <Button
                      id="addNewDocument"
                      name="addNewDocument"
                      variant="contained"
                      color="primary"
                      startIcon={<InlineIcon icon={PlusIcon} />}
                      onClick={handleButtonClick}
                      disableElevation
                    >
                      {t("MY_DOCUMENTS_NEW_DOCUMENTS")}
                    </Button>
                    <Box height="32px" />
                  </Box>
                </Box>
              )}
              <MyDocumentsInfoCard
                isUser={!!isUser}
                isUploader={isUploader}
                contractCode={contractCode}
                onEditDocument={handleEditDocument}
                editDocument={editDocument}
                onCloseEdit={handleCloseEdit}
              />
              <Box height="16px" />
            </OcCard>
            {isUser && (
              <>
                <Box height="16px" />
                <Box width="240px">
                  <OcCard
                    label={t("MY_DOCUMENTS_UPLOADERS")}
                    loading={!data && loading}
                    error={!!error}
                  >
                    <Box>
                      <MyDocumentsUploaders
                        uploadersData={data}
                        loading={loading}
                      />
                    </Box>
                  </OcCard>
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>
    </OcPageTransition>
  );
};

export default MyDocumentsDataPanel;
